// 2024(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import bootstrap from "~bootstrap/dist/js/bootstrap.bundle";

export function Router() { }

Router.prototype = {

    markActive: function (parent = null, active_class = 'active') {
        let path = window.location.pathname + window.location.search + window.location.hash;

        let elements = (parent !== null) ? 
            document.querySelectorAll(parent + ' [data-nav-active]') : 
            document.querySelectorAll('[data-nav-active]');
        
        for (let i = 0; i < elements.length; ++i)
        {
            let el = elements[i];
            let re = new RegExp(el.dataset.navActive);
            if (path.search(re) != -1) {
                el.setAttribute('class', (el.getAttribute('class') + ' ' + active_class).trim());
            }
        }
    },

    markSelected: function (parent = null) {
        let path = window.location.pathname + window.location.search + window.location.hash;

        let elements = (parent !== null) ? 
            document.querySelectorAll(parent + ' [data-nav-selected]') : 
            document.querySelectorAll('[data-nav-selected]');
        
        for (let i = 0; i < elements.length; ++i)
        {
            let el = elements[i];
            let re = new RegExp(el.dataset.navSelected);
            if (path.search(re) != -1) {
                el.setAttribute('selected', '');
            }
        }
    }

};

export function init() {

    // Show and hide side navigation menu
    var sidebarCollapseEls = document.querySelectorAll('.sidebar.nav-collapse');
    
    if (sidebarCollapseEls.length > 0)
    {
        var sidebarNavCollapser = new bootstrap.Collapse(sidebarCollapseEls[0], {
            toggle: false
        });
        
        sidebarCollapseEls[0].addEventListener('hidden.bs.collapse', event => {
            let btnIcon = document.querySelectorAll("#nav-collapse-btn .icons")[0];
            btnIcon.innerHTML = "menu";
        });
        sidebarCollapseEls[0].addEventListener('show.bs.collapse', event => {
            let btnIcon = document.querySelectorAll("#nav-collapse-btn .icons")[0];
            btnIcon.innerHTML = "menu_open";
        });
    }

    // Set active link in side navigation
    let router = new Router();
    router.markActive();
    router.markSelected();
    
}